import React from 'react';
import VstComponent from './VstComponent';

class VstLilHeadLink extends VstComponent {

  render() {
    return (
      <ul className="vst-lil-head-list">
        <li className="vst-lil-head-divider"></li>
        {this.props.children}
      </ul>
    );
  }

}

export default VstLilHeadLink;
